<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.create_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Registrar Socio</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-row justify="center" align="center">
                        <v-col cols="12" lg="5" md="8" sm="12" xs=12>
                            <v-form ref="partnership_form" v-on:submit.prevent="submit">
                                <v-text-field v-model="names" filled :rules="[rules.required]" color="#000" label="Nombre(s)"></v-text-field>
                                <v-row no-gutters>
                                    <v-text-field v-model="paternal_surname" filled :rules="[rules.required]" color="#000" label="Apellido paterno"></v-text-field>
                                    <v-text-field v-model="maternal_surname" filled :rules="[rules.required]" color="#000" label="Apellido materno"></v-text-field>
                                </v-row>
                                <v-row no-gutters>
                                    <v-text-field v-model="phone" type="number" :rules="[rules.required, rules.phone]" min="1" filled color="#000" label="Teléfono"></v-text-field>
                                    <v-text-field v-model="name" filled :rules="[rules.required]" color="#000" label="Nombre de usuario"></v-text-field>
                                </v-row>
                                <v-text-field v-model="email" filled :rules="[rules.required, rules.email]" type="email" color="#000" label="Correo electrónico"></v-text-field>
                                <v-row no-gutters>
                                    <v-text-field v-model="password" type="password" :rules="[rules.required, rules.length]" filled color="000" label="Contraseña"></v-text-field>
                                    <v-text-field v-model="password_confirmation" type="password" :rules="[rules.required, rules.length]" filled color="000" label="Repetir contraseña"></v-text-field>
                                </v-row>
                                <v-text-field v-model="pagename" filled :rules="[rules.required]" color="#000" label="Nombre de página"></v-text-field>
                                <v-text-field v-model="page_url" filled :rules="[rules.required]" color="#000" label="Enlace de página"></v-text-field>
                                <v-text-field v-model="link" filled :rules="[rules.required]" color="#000" label="Enlace"></v-text-field>
                                <v-text-field v-model="agreement" type="number" :rules="[rules.required]" min="1" filled color="#000" label="Acuerdo mensual"></v-text-field>
                                <v-text-field v-model="quantity" type="number" :rules="[rules.required]" min="1" filled color="#000" label="Descuento"></v-text-field>

                                <v-row no-gutters>
                                    <v-spacer></v-spacer>
                                    <v-btn color="#000" :disabled="loading" @click="$parent.create_dialog = false" text>Cancelar</v-btn>
                                    <v-btn color="#008dd4" :loading="loading" type="submit" dark>Registrar</v-btn>
                                </v-row>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['dialog','store_url'],
    data: () => ({
        loading:false,

        names:"",
        paternal_surname:"",
        maternal_surname:"",
        phone:"",
        name:"",
        email:"",
        password:"",
        password_confirmation:"",
        pagename:"",
        page_url:"",
        link:"",
        agreement:"",
        quantity:"",

        rules:{
            required: v => !!v || 'El campo es requerido',
            email: v => /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(v) || 'El Correo electrónico ingresado no es válido',
            length: v  => !!v && v.length >= 8 || 'Debe contener al menos 8 caracteres',
            phone: v => !!v && v.length >= 10 || 'Debe contener al menos 10 caracteres',
        },
    }),

    methods:{
        submit:function(){
            if(this.$refs.partnership_form.validate()){
                this.loading = true
                let data = {}
                data.names = this.names
                data.paternal_surname = this.paternal_surname
                data.maternal_surname = this.maternal_surname
                data.phone = this.phone
                data.name = this.name
                data.email = this.email
                data.password = this.password
                data.password_confirmation = this.password_confirmation
                data.pagename = this.pagename
                data.page_url = this.page_url
                data.link = this.link
                data.agreement = this.agreement
                data.quantity = this.quantity

                axios.post(this.store_url, data).then(response => {
                    this.$refs.partnership_form.reset()
                    this.$parent.create_dialog = false
                    iziToast.success({
                        title:"Correcto",
                        message:"Socio registrado correctamente",
                        position:"topRight"
                    })
                    this.$parent.getData()

                }).catch(error => {
                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }
                })

                this.loading = false
            }
        }
    }
}
</script>